import React, { useState } from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, ButtonProps } from '@mui/material';

type Props = {
  text: string;
  disabled?: boolean;
  label?: string;
  copiedLabel?: string;
} & Omit<ButtonProps, 'onClick'>;

export const CopyButton: React.FC<Props> = ({
  text,
  disabled = false,
  label = 'Копировать',
  copiedLabel = 'Скопировано',
  ...buttonProps
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error('CopyButton: failed to copy', e);
    }
  };

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<ContentCopyIcon />}
      disabled={copied || disabled}
      onClick={handleCopy}
      aria-label={label}
      {...buttonProps}
    >
      {copied ? copiedLabel : label}
    </Button>
  );
};
